export default __webpack_public_path__ + "static/media/accelerate-inverse-1.1b6e6d5b.webp";